export default "__VITE_ASSET__c9a40a4a__"